import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import JsonData from "../data/data.json";
import { MalluPhone } from "./mallupay/MalluPhone";

export const Gallery = () => {
  const { t } = useTranslation("landing");
  const domain = JsonData?.Gallery?.nameBankDomain || "mallupay";
  const urlRegister = `https://app.${domain}.com.br/register`;

  const openInNewTab = (url) => {
    window.open(url, "_blank", "noreferrer");
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("visible");
            observer.unobserve(entry.target);
          }
        });
      },
      { root: null, rootMargin: "0px", threshold: 0 }
    );

    document.querySelectorAll("#gallery .reveal").forEach((el) => observer.observe(el));

    return () => observer.disconnect();
  }, []);

  return (
    <div id="gallery">
      <div className="container">
        <div className="row d-flex">
          <div className="col-xs-12 col-md-6">
            <div className="about-text">
              <h2 className="reveal">{t("gallery.title")}</h2>
              <button
                className="btn btn-custom btn-outlined-white btn-lg page-scroll reveal"
                onClick={() => openInNewTab(urlRegister)}
              >
                {t("gallery.openAccount")}
              </button>
            </div>
          </div>
          <div className="col-xs-12 col-md-6 gallery-phone-wrap">
            <MalluPhone className="gallery-phone reveal" />
          </div>
        </div>
      </div>
    </div>
  );
};
